<template>
  <section class="portfolio-section" ref="portfolioRef">
    <div class="portfolio-container">
      
      <!-- HEADER CON COPY DE ALTO IMPACTO -->
      <div class="portfolio-header" ref="headerRef">
        <p class="portfolio-label">ELLAS YA VIVIERON LA EXPERIENCIA</p>
        <h2 class="portfolio-title">
          Quinceañeras <br />
          <span>Que nos han contratado</span>
        </h2>
        <p class="portfolio-subtitle">Un recorrido por el brillo, estilo y magia de nuestras creaciones más exclusivas.</p>
      </div>

      <!-- CONTADOR DE ULTRA LUJO CON DESTELLOS MÁGICOS -->
      <div class="counter-luxury-wrapper" ref="counterWrapperRef">
        <!-- Contenedor de partículas/brillos de fondo -->
        <div class="sparkles-container" ref="sparklesContainerRef"></div>
        
        <div class="counter-box">
          <span class="counter-number" ref="counterNumRef">0</span>
          <span class="counter-plus">+</span>
        </div>
        <p class="counter-label">Invitaciones mágicas entregadas y contando</p>
      </div>
    </div>

    <!-- CONTENEDOR DE PASARELAS INFINITAS DE PRIMER NIVEL (LOOK TOP 2026) -->
    <div class="marquee-master-container">
      
      <!-- FILA 1: DESPLAZAMIENTO HACIA LA IZQUIERDA -->
      <div class="marquee-row" ref="rowIzquierdaRef">
        <div class="marquee-track line-left">
          <!-- Duplicamos el array para el efecto espejo infinito perfecto -->
          <div 
            v-for="(item, index) in [...invitations, ...invitations]" 
            :key="'left-' + index" 
            class="portfolio-item-luxury"
          >
            <div class="portfolio-card-luxury">
              <div class="card-image-wrapper">
                <img :src="item.image" :alt="item.name" class="card-img" />
                <div class="card-overlay">
                  <div class="overlay-content">
                    <span class="badge-fifteen">✦ 15 Años Premium</span>
                    <h3 class="card-name">{{ item.name }}</h3>
                    <p class="card-style">{{ item.style }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- FILA 2: DESPLAZAMIENTO HACIA LA DERECHA -->
      <div class="marquee-row" ref="rowDerechaRef">
        <div class="marquee-track line-right">
          <div 
            v-for="(item, index) in [...invitations, ...invitations]" 
            :key="'right-' + index" 
            class="portfolio-item-luxury"
          >
            <div class="portfolio-card-luxury">
              <div class="card-image-wrapper">
                <img :src="item.image" :alt="item.name" class="card-img" />
                <div class="card-overlay">
                  <div class="overlay-content">
                    <span class="badge-fifteen">✦ 15 Años Premium</span>
                    <h3 class="card-name">{{ item.name }}</h3>
                    <p class="card-style">{{ item.style }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </section>
</template>

<script>
import { ref, onMounted, nextTick } from 'vue'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'PortfolioQuinceaneras',
  setup() {
    const portfolioRef = ref(null)
    const headerRef = ref(null)
    const rowIzquierdaRef = ref(null)
    const rowDerechaRef = ref(null)
    
    const counterWrapperRef = ref(null)
    const counterNumRef = ref(null)
    const sparklesContainerRef = ref(null)

    const invitations = [
      {
        name: 'Melanie',
        style: 'Elegancia Modern Rose',
        image: require('@/assets/IMG_8745 (1).webp')
      },
      {
        name: 'Isabel Zorrila',
        style: 'Detalles Brillantes Magia',
        image: require('@/assets/IMG_9581.webp')
      },
      {
        name: 'Isabel Zorrila',
        style: 'Detalles Brillantes Magia',
        image: require('@/assets/8E797218-12F3-4AA5-8B6B-607B07D44B75.webp')
      },
      {
        name: 'Brianna Nicole',
        style: 'Cinematográfico / Glamour',
        image: require('@/assets/_DSC3449.webp')
      },
      {
        name: 'Allison Nicole',
        style: 'Lujo Real Sparkling',
        image: require('@/assets/nuevafoto.jpg')
      },
      {
        name: 'Nicole Danielle',
        style: 'Inmersivo Minimalist Gold',
        image: require('@/assets/IMG_4165.webp')
      },
      {
        name: 'Johanna',
        style: 'Revista Digital Premium',
        image: require('@/assets/NIK_4222.webp')
      },
      {
        name: 'Aillen',
        style: 'Detalles Brillantes Magia',
        image: require('@/assets/portadaailen.webp')
      }
    ]

    // Sistema de destellos refinados
    const createSparkle = () => {
      if (!sparklesContainerRef.value) return
      
      const sparkle = document.createElement('div')
      sparkle.className = 'sparkle-star'
      
      sparkle.innerHTML = `
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 0L14.8 9.2L24 12L14.8 14.8L12 24L9.2 14.8L0 12L9.2 9.2L12 0Z" fill="url(#sparkleGrad)"/>
          <defs>
            <linearGradient id="sparkleGrad" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stop-color="#e293a0" />
              <stop offset="50%" stop-color="#f5cad2" />
              <stop offset="100%" stop-color="#e6b89c" />
            </linearGradient>
          </defs>
        </svg>
      `
      
      const size = Math.random() * 16 + 12 
      sparkle.style.width = `${size}px`
      sparkle.style.height = `${size}px`
      // Centrados elegantemente detrás y alrededor del texto
      sparkle.style.left = `${Math.random() * 70 + 15}%`
      sparkle.style.top = `${Math.random() * 50 + 25}%`
      
      sparklesContainerRef.value.appendChild(sparkle)
      
      gsap.fromTo(sparkle, 
        { scale: 0, opacity: 0, rotation: -20 },
        { 
          scale: 1, 
          opacity: Math.random() * 0.8 + 0.4, 
          rotation: Math.random() * 90, 
          duration: 0.5, 
          ease: 'power2.out',
          onComplete: () => {
            gsap.to(sparkle, {
              scale: 0,
              opacity: 0,
              y: -40,
              duration: 0.9,
              ease: 'power1.inOut',
              onComplete: () => sparkle.remove()
            })
          }
        }
      )
    }

    onMounted(async () => {
      await nextTick()

      // Importar Playfair Display dinámicamente si no está en el proyecto
      if (!document.getElementById('google-font-playfair')) {
        const link = document.createElement('link')
        link.id = 'google-font-playfair'
        link.rel = 'stylesheet'
        link.href = 'https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,600;0,700;1,400&display=swap'
        document.head.appendChild(link)
      }

      // 1. Animación del Header
      gsap.from(headerRef.value.children, {
        opacity: 0,
        y: 40,
        duration: 1,
        stagger: 0.2,
        ease: 'power3.out',
        scrollTrigger: {
          trigger: portfolioRef.value,
          start: 'top 80%',
          once: true
        }
      })

      // 2. Animación del Contador con la nueva tipografía editorial
      const targetValue = { val: 0 }
      let sparkleInterval = null

      gsap.from(counterWrapperRef.value, {
        opacity: 0,
        y: 30,
        duration: 1.2,
        ease: 'power3.out',
        scrollTrigger: {
          trigger: counterWrapperRef.value,
          start: 'top 85%',
          once: true,
          onEnter: () => {
            sparkleInterval = setInterval(() => {
              createSparkle()
              if(Math.random() > 0.3) createSparkle()
            }, 60)

            gsap.to(targetValue, {
              val: 899,
              duration: 3, 
              ease: 'power3.out', // Transición más suave al final
              onUpdate: () => {
                if (counterNumRef.value) {
                  counterNumRef.value.innerText = Math.floor(targetValue.val)
                }
              },
              onComplete: () => {
                clearInterval(sparkleInterval)
                // Pequeños destellos elegantes continuos cuando se detiene
                setInterval(() => {
                  if (document.visibilityState === 'visible') createSparkle()
                }, 800)
              }
            })
          }
        }
      })

      // 3. Loop Infinito Fila Izquierda
      const trackLeft = rowIzquierdaRef.value.querySelector('.line-left')
      const itemsLeft = trackLeft.children
      const totalWidthLeft = (itemsLeft[0].offsetWidth + 25) * invitations.length

      const animLeft = gsap.to(trackLeft, {
        x: -totalWidthLeft,
        duration: 25, 
        ease: 'none',
        repeat: -1
      })

      // 4. Loop Infinito Fila Derecha
      const trackRight = rowDerechaRef.value.querySelector('.line-right')
      gsap.set(trackRight, { x: -totalWidthLeft }) 

      const animRight = gsap.to(trackRight, {
        x: 0,
        duration: 25,
        ease: 'none',
        repeat: -1
      })

      // 5. Interacciones táctiles y mouse
      const ralentizar = () => {
        gsap.to([animLeft, animRight], { timeScale: 0.2, duration: 0.5, ease: 'power2.out' })
      }
      const reanudar = () => {
        gsap.to([animLeft, animRight], { timeScale: 1, duration: 0.8, ease: 'power2.out' })
      }

      const masterContainer = document.querySelector('.marquee-master-container')
      masterContainer.addEventListener('mouseenter', ralentizar)
      masterContainer.addEventListener('mouseleave', reanudar)
      masterContainer.addEventListener('touchstart', ralentizar, { passive: true })
      masterContainer.addEventListener('touchend', reanudar, { passive: true })
    })

    return { 
      portfolioRef, 
      headerRef, 
      rowIzquierdaRef, 
      rowDerechaRef, 
      invitations,
      counterWrapperRef,
      counterNumRef,
      sparklesContainerRef
    }
  }
}
</script>

<style scoped>
/* PALETA DE ULTRA LUJO REFRESCANTE */
.portfolio-section {
  padding: 120px 0 100px 0;
  background: #fffefc; 
  color: #2b2927;
  overflow: hidden;
  position: relative;
}

.portfolio-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 4%;
}

.portfolio-header {
  text-align: center;
  margin-bottom: 50px;
}

.portfolio-label {
  font-family: 'Montserrat', sans-serif;
  font-size: 0.75rem;
  letter-spacing: 4px;
  color: #e293a0;
  font-weight: 700;
  margin-bottom: 12px;
}

.portfolio-title {
  font-size: 3.5rem;
  color: #2b2927;
  line-height: 1.15;
  margin: 0 0 15px 0;
  font-family: 'Montserrat', sans-serif;
  font-weight: 700;
}

.portfolio-title span {
  font-family: 'ludovica', serif;
  font-style: italic;
  font-weight: 400;
  background: linear-gradient(45deg, #e293a0, #bfa18f, #d4a373);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.portfolio-subtitle {
  color: #6a6561;
  font-family: 'Montserrat', sans-serif;
  font-size: 1rem;
  max-width: 600px;
  margin: 0 auto;
}

/* ==========================================================================
   NUEVO CONTADOR DE REVISTA DE MODA CON FUENTE PLAYFAIR DISPLAY
   ========================================================================== */
.counter-luxury-wrapper {
  text-align: center;
  margin-bottom: 85px;
  position: relative;
  display: inline-block;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;
}

.counter-box {
  display: inline-flex;
  align-items: baseline; /* Alineación perfecta con la base del número */
  justify-content: center;
}

.counter-number {
  font-family: 'Playfair Display', serif; /* Cambiado a Playfair de Alta Gama */
  font-weight: 700;
  font-size: 7rem; /* Un poco más grande para imponer jerarquía visual de lujo */
  letter-spacing: -2px;
  line-height: 1;
  background: linear-gradient(180deg, #2b2927 20%, #6e6560 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-variant-numeric: tabular-nums;
}

.counter-plus {
  font-family: 'Playfair Display', serif;
  font-size: 4.5rem;
  font-weight: 400;
  font-style: italic; /* El '+' inclinado en serif se ve espectacular */
  color: #e293a0;
  margin-left: 4px;
  line-height: 1;
}

.counter-label {
  font-family: 'Montserrat', sans-serif;
  font-size: 0.85rem;
  letter-spacing: 3px;
  text-transform: uppercase;
  color: #bfa18f;
  margin-top: 10px;
  font-weight: 600;
}

/* Contenedor de Brillos */
.sparkles-container {
  position: absolute;
  inset: -20px -60px;
  pointer-events: none;
  overflow: visible;
}

:deep(.sparkle-star) {
  position: absolute;
  pointer-events: none;
  z-index: 5;
  filter: drop-shadow(0 4px 6px rgba(226, 147, 160, 0.3));
}

/* ==========================================================================
   PASARELAS INFINITAS
   ========================================================================== */
.marquee-master-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 25px; 
  cursor: grab;
  position: relative;
}

.marquee-master-container:active {
  cursor: grabbing;
}

.marquee-row {
  width: 100%;
  overflow: hidden;
  display: flex;
}

.marquee-track {
  display: flex;
  gap: 25px;
  white-space: nowrap;
  will-change: transform;
}

.portfolio-item-luxury {
  width: 310px; 
  flex-shrink: 0;
}

.portfolio-card-luxury {
  width: 100%;
  display: block;
}

.card-image-wrapper {
  position: relative;
  aspect-ratio: 3 / 4;
  border-radius: 24px;
  overflow: hidden;
  background: #faf7f4;
  box-shadow: 0 15px 35px rgba(186, 171, 157, 0.2);
  border: 1px solid rgba(212, 163, 115, 0.15);
  will-change: transform;
  transition: transform 0.4s cubic-bezier(0.16, 1, 0.3, 1);
}

.card-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.card-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(360deg, rgba(43, 41, 39, 0.85) 0%, rgba(0, 0, 0, 0) 60%);
  display: flex;
  align-items: flex-end;
  padding: 25px;
  opacity: 0;
  transition: opacity 0.4s ease;
}

.overlay-content {
  text-align: left;
  transform: translateY(15px);
  transition: transform 0.4s cubic-bezier(0.16, 1, 0.3, 1);
}

.badge-fifteen {
  font-family: 'Montserrat', sans-serif;
  font-size: 0.65rem;
  font-weight: 700;
  text-transform: uppercase;
  color: #f0b2bc;
  letter-spacing: 1px;
  display: block;
  margin-bottom: 5px;
}

.card-name {
  font-family: 'ludovica', serif;
  font-size: 1.6rem;
  color: white;
  margin: 0;
  font-weight: 400;
}

.card-style {
  font-family: 'Montserrat', sans-serif;
  font-size: 0.8rem;
  color: #dddddd;
  margin-top: 4px;
  white-space: normal;
}

/* HOVERS */
@media (hover: hover) {
  .card-image-wrapper:hover {
    transform: scale(1.02);
    box-shadow: 0 25px 50px rgba(186, 171, 157, 0.35);
  }

  .card-image-wrapper:hover .card-overlay {
    opacity: 1;
  }

  .card-image-wrapper:hover .overlay-content {
    transform: translateY(0);
  }
}

/* RESPONSIVE MÓVIL */
@media (max-width: 768px) {
  .portfolio-section {
    padding: 80px 0 70px 0;
  }
  
  .portfolio-title {
    font-size: 2.3rem;
  }

  .counter-luxury-wrapper {
    margin-bottom: 55px;
  }

  .counter-number {
    font-size: 4.8rem; /* Proporción premium ajustada a móviles */
  }

  .counter-plus {
    font-size: 3.2rem;
  }

  .portfolio-item-luxury {
    width: 220px; 
  }

  .card-overlay {
    opacity: 1;
    background: linear-gradient(360deg, rgba(43, 41, 39, 0.9) 0%, rgba(0, 0, 0, 0) 70%);
    padding: 15px;
  }

  .overlay-content {
    transform: translateY(0);
  }

  .card-name {
    font-size: 1.25rem;
  }

  .card-style {
    font-size: 0.72rem;
  }
}
</style>